export default {
    brush: {
        title: 'Pinsel',
        brushHardness: 'Pinselhärte',
        brushSize: 'Pinselgröße',
        brushColor: 'Bürstenfarbe',
    },
};
